import React, { useState, useEffect } from 'react';
import '../../components/Task/WorklogReport/WorklogReport.css';
import Navbar from '../Navbar/Navbar';
import DatePicker from 'react-datepicker';
import { useDispatch, useSelector } from "react-redux";
import { empList } from '../../Redux/DailyUpdateApproval/Action';
import { auditStampingList } from '../../Redux/Auth/Action';
import Select from "react-select";
import NewDataTable from '../DataTable/NewDataTable';
import { format, parseISO, startOfMonth } from "date-fns";


const AuditStampingList = () => {
    const dispatch = useDispatch();
    const token = localStorage.getItem("token");
    const [fromDate, setFromDate] = useState(startOfMonth(new Date()));
    const [toDate, setToDate] = useState(new Date());
    const { emplists } = useSelector((store) => store.dailyUpdateApprover);
    const [selectedEmployee, setSelectedEmployee] = useState(null);


    const { auditList } = useSelector((store) => store.auth);


    const handleEmpChange = (selectedOption) => {
        setSelectedEmployee(selectedOption);
    };

    useEffect(() => {
        dispatch(empList(token, "All"));
    }, [])

    let options = [
        { value: 'All', label: 'All' },
        ...emplists.map((emp) => ({
            value: emp.loginId,
            label: `${emp?.firstName || ""} ${emp?.lastName || ""}`,
        })),
    ];

    useEffect(() => {
        if (options.length > 0 && selectedEmployee === null) {
            setSelectedEmployee(options[0]);
        }
    }, [options, selectedEmployee]);


    useEffect(() => {
        if (selectedEmployee && fromDate && toDate) {
            dispatch(auditStampingList(selectedEmployee.value, format(fromDate, "yyyy-MM-dd"), format(toDate, "yyyy-MM-dd"), token));
        }
    }, [dispatch, selectedEmployee, fromDate, toDate,])

    const columns = [
        {
            name: "SN",
            cell: (_, index) => index + 1,
            sortable: false,
            width: "60px",
            align: "center",
        },
        {
            name: "Employee",
            selector: (row) => row.loginId || "-",
            sortable: true,
            align: "left",
        },

        {
            name: "Login Date Time",
            selector: (row) =>
                row.loginDateTime
                    ? format(parseISO(row.loginDateTime), "dd-MM-yyyy HH:mm:ss")
                    : "-",
            sortable: true,
            align: "center",
        },

        {
            name: "IP Address",
            selector: (row) => row.ipAddress || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Logout Type",
            selector: (row) => row.logOutType || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Logout Date Time",
            selector: (row) =>
                row.logOutDateTime
                    ? format(parseISO(row.logOutDateTime), "dd-MM-yyyy HH:mm:ss")
                    : "-",
            sortable: true,
            align: "center",
        },
    ];


    return (
        <div>
            <Navbar></Navbar>

            <div className="main-content">
                <div className="container-fluid mt-4">
                    <div className="row mb-3 justify-content-end align-items-center flex-wrap">

                        {/* Employee Select */}
                        <div className="col-auto d-flex align-items-center flex-nowrap mb-2 mb-sm-0">
                            <b>
                                <label className="me-1 mb-0 custom-label">Employee:</label>
                            </b>
                            <div style={{ width: "300px" }}>
                                <Select
                                    options={options}
                                    value={selectedEmployee}
                                    onChange={handleEmpChange}
                                    placeholder="Select Employee"
                                    isClearable
                                />
                            </div>
                        </div>

                        {/* From & To Dates in one row */}
                        <div className="col-auto d-flex align-items-center flex-nowrap mb-2 mb-sm-0">
                            <b>
                                <label className="me-1 mb-0 custom-label cstm-label">From Date:</label>
                            </b>
                            <DatePicker
                                selected={fromDate}
                                onChange={(newValue) => setFromDate(newValue)}
                                className="form-control me-3"
                                dateFormat="dd-MM-yyyy"
                                showYearDropdown
                                showMonthDropdown
                                dropdownMode="select"
                                onKeyDown={(event) => event.preventDefault()}
                            />

                            <b>
                                <label className="me-1 ms-2 mb-0 custom-label cstm-label">To Date:</label>
                            </b>
                            <DatePicker
                                selected={toDate}
                                onChange={(newValue) => setToDate(newValue)}
                                className="form-control"
                                dateFormat="dd-MM-yyyy"
                                showYearDropdown
                                showMonthDropdown
                                dropdownMode="select"
                                onKeyDown={(event) => event.preventDefault()}
                                minDate={fromDate}
                            />
                        </div>

                    </div>

                    <div>
                        <NewDataTable
                            columns={columns}
                            data={auditList || []}
                            tableName="AUDIT STAMPING LIST"
                            totalRecord={auditList?.length}
                        />
                    </div>
                </div>
            </div>
        </div>

    );
};

export default AuditStampingList;